import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/application/application-section.ts
var ApplicationSection = class extends s {
  hasBreakpoint(breakpoint) {
    if (this.breakpoint === breakpoint)
      return true;
    return !this.breakpoint && this.applicationBreakpoint === breakpoint;
  }
  firstUpdated() {
    const app = document.querySelector("fadv-application");
    this.applicationBreakpoint = app == null ? void 0 : app.getAttribute("breakpoint");
  }
  renderContainer() {
    return $`<div class=${o({
      container: !this.breakpoint && !this.applicationBreakpoint,
      "container-sm": this.hasBreakpoint("sm"),
      "container-md": this.hasBreakpoint("md"),
      "container-lg": this.hasBreakpoint("lg"),
      "container-xl": this.hasBreakpoint("xl"),
      "container-xxl": this.hasBreakpoint("xxl"),
      "container-fluid": this.hasBreakpoint("fluid")
    })} ><slot></slot></div>`;
  }
};
__decorateClass([
  e({ reflect: true })
], ApplicationSection.prototype, "breakpoint", 2);
__decorateClass([
  t()
], ApplicationSection.prototype, "applicationBreakpoint", 2);

export {
  ApplicationSection
};
